package com.rosario.juridico.premium

import kotlinx.datetime.Clock
import kotlinx.serialization.Serializable

/**
 * Estados de consistencia del derecho premium.
 */
enum class EntitlementConsistencyState {
    SERVER_SYNCED,      // Datos frescos del servidor
    STALE_CACHE,        // Datos de cache con más de 5 minutos
    LOCAL_ONLY,         // Datos cargados de cache (inicio inmediato)
    EXPIRED,            // El premium ha vencido (fuera de periodo de gracia)
    GRACE_PERIOD,       // El premium venció pero se mantiene acceso temporal por falta de sync
    RESTORED            // Recuperado tras proceso de restauración
}

/**
 * Estados de sincronización para UX.
 */
enum class SyncStatus {
    IDLE,
    SYNCING,
    RETRYING,
    FAILED_TEMPORARILY,
    OFFLINE
}

/**
 * Modelo tipado para la gestión de derechos (entitlements) premium.
 * Reemplaza progresivamente la lógica basada en booleanos dispersos.
 */
@Serializable
data class PremiumEntitlement(
    val plan: String = "free",
    val expiresAt: Long = 0L,
    val source: String = "",
    val isActiveManual: Boolean = false,
    val purchaseId: String = "none",
    val consistency: EntitlementConsistencyState = EntitlementConsistencyState.LOCAL_ONLY
) {
    /**
     * Calcula si el derecho premium es válido en el momento actual.
     */
    val isCurrentlyActive: Boolean
        get() = isActiveManual && (expiresAt <= 0L || expiresAt > Clock.System.now().toEpochMilliseconds())

    /**
     * Helper para determinar si el plan es gratuito.
     */
    val isFree: Boolean get() = !isCurrentlyActive

    companion object {
        /**
         * Retorna un entitlement por defecto para usuarios nuevos o gratuitos.
         */
        fun free() = PremiumEntitlement(
            plan = "free", 
            expiresAt = 0L, 
            source = "", 
            isActiveManual = false,
            consistency = EntitlementConsistencyState.SERVER_SYNCED
        )
    }
}
